import { render, staticRenderFns } from "./MotoboyObject.vue?vue&type=template&id=dac37cd6"
import script from "./MotoboyObject.vue?vue&type=script&lang=js"
export * from "./MotoboyObject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports